import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TOU_en from './TOU_en';
import TOU_fr from './TOU_fr';
import './styles.css';
const TOU = () => {
    const { i18n: { resolvedLanguage = 'en' } = {} } = useTranslation();
    return (_jsx(Box, { sx: {
            mb: 2,
            height: { desktop: '494px', mobile: '400px' },
            overflowY: 'auto',
            maxHeight: '550px',
            border: '1px solid #eee',
            borderRadius: '8px',
            padding: '10px 16px',
            h2: {
                fontFamily: 'Avenir-Black, sans-serif',
            },
        }, tabIndex: 0, children: resolvedLanguage === 'en' ? _jsx(TOU_en, {}) : _jsx(TOU_fr, {}) }));
};
export default TOU;
